import type { ProLayoutProps } from '@ant-design/pro-components';
import { getNavigationToken } from '../src/theme/config';
import { BizAppConfig } from './application.manifest';
import { getBrandAppName } from './brand';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'realDark',
  colorPrimary: '#1890ff',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  pwa: true,
  title: getBrandAppName(),
  logo: BizAppConfig.appLogo,
  token: getNavigationToken('realDark'),
  splitMenus: false,
  collapsed: true,
  siderWidth: 208,
  siderMenuType: 'group',
};
export default Settings;
